module.exports = __webpack_public_path__ + "img/sm-ios.2ba9302f.png";